@if (!phoneNumber) {
    <div data-bb="phone-error">
        <p>
            <strong>
                <ap-content key="phone-number.title.missing.error"></ap-content>
            </strong>
        </p>
        <ap-notification status="error">
            <p>
                <ap-content key="phone-number.missing.error"></ap-content>
            </p>
        </ap-notification>
    </div>
} @else {
    <p>
        <strong data-bb="phoneNumber.number">
            <ap-content key="phone-number.instruction" [params]="{ phoneNumber: '<span>' + phoneNumber + '</span>' }"></ap-content>
        </strong>
    </p>
    <ap-activation-code-input [formControl]="signResponse" [messages]="signResponseErrors"></ap-activation-code-input>

    @if (codeStatus) {
        <ap-notification [status]="codeStatus" id="resend-notification">
            {{ notificationContent }}
        </ap-notification>
    }

    <p>
        @if (canSign && !maxOtpCodesError) {
            <span class="ap-sign__phone-number__link">
                {{ 'phone-number.no-code' | apContent }}
                <ap-button [text]="true" [isDisabled]="disableResend" (onClick)="sendCode()" data-bb="resend">
                    <span [attr.aria-hidden]="disableResend ? 'true' : null">
                        {{ 'phone-number.resend-code' | apContent }}
                        @if (disableResend) {
                            @if (cooldown) {
                                <span role="timer">({{ cooldown }})</span>
                            } @else {
                                <ap-spinner
                                    size="xsmall"
                                    [visuallyHiddenLabel]="true"
                                    [loadingText]="'phone-number.spinner.loading' | apContent"
                                    [readyText]="'phone-number.spinner.ready' | apContent"
                                ></ap-spinner>
                            }
                        }
                    </span>
                    @if (disableResend) {
                        <div class="ap-sr-only">{{ disabledContent }}</div>
                    }
                </ap-button>
            </span>
        }

        @if (!anonymous()) {
            <span class="ap-sign__phone-number__link" data-bb="phone-reset">
                {{ 'phone-number.wrong-number' | apContent }}
                <ap-button [text]="true" (onClick)="changePhoneNumber()">{{ 'phone-number.wrong-number.link-text' | apContent }}</ap-button>
            </span>
        }
        @if (showRetryLink) {
            <span class="ap-sign__phone-number__link">
                {{ 'phone-number.new-number' | apContent }}
                <ap-button [text]="true" (onClick)="newNumber()">{{ 'phone-number.retry' | apContent }}</ap-button>
            </span>
        }
    </p>

    <div class="ap-sign__phone-number__buttons">
        @if (cancelText()) {
            <ap-button data-bb="cancel" variant="secondary" (onClick)="cancel()">
                {{ cancelText() }}
            </ap-button>
        }
        <ap-submit [canSign]="canSign" [submitText]="submitText()" (submitted)="sign()"></ap-submit>
    </div>
}
